import { render, staticRenderFns } from "./groupPurchaseIndex.vue?vue&type=template&id=00b75fcb&scoped=true"
import script from "./groupPurchaseIndex.vue?vue&type=script&lang=js"
export * from "./groupPurchaseIndex.vue?vue&type=script&lang=js"
import style0 from "./groupPurchaseIndex.vue?vue&type=style&index=0&id=00b75fcb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b75fcb",
  null
  
)

export default component.exports